import React from 'react';

export function PlayIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
		<g filter="url(#filter0_d_16120_4818)">
			<path d="M29.9453 47.3672C41.5433 47.3672 50.9453 37.9652 50.9453 26.3672C50.9453 14.7692 41.5433 5.36719 29.9453 5.36719C18.3473 5.36719 8.94531 14.7692 8.94531 26.3672C8.94531 37.9652 18.3473 47.3672 29.9453 47.3672Z" fill="white" />
			<path d="M36.6973 25.5355L27.5 19.404C26.8355 18.961 25.9453 19.4373 25.9453 20.236V32.499C25.9453 33.2977 26.8355 33.7741 27.5 33.3311L36.6972 27.1996C37.291 26.8038 37.291 25.9313 36.6973 25.5355Z" fill="#004FE0" />
		</g>
		<defs>
			<filter id="filter0_d_16120_4818" x="0.00333023" y="0.00199795" width="59.884" height="59.884" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="3.57679" />
				<feGaussianBlur stdDeviation="4.47099" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16120_4818" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16120_4818" result="shape" />
			</filter>
		</defs>
	</svg>);
}